document.documentElement.classList.remove('no-js');
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function setMenu(open) {
    var toggle = document.querySelector('.site-header:not([data-asphalt-probe]) .mobile-toggle');
    var menu = document.querySelector('.site-header:not([data-asphalt-probe]) .mobile-menu');
    if (!toggle || !menu) return;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    menu.hidden = !open;
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.mobile-toggle');
    if (toggle) setMenu(toggle.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var toggle = document.querySelector('.site-header:not([data-asphalt-probe]) .mobile-toggle');
    if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
      setMenu(false);
      toggle.focus();
    }
  });
  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      });
  }
  document.addEventListener('cart:updated', function () {
    refreshCartCount().catch(function () {});
  });
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('.quick-form');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('button');
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Ajout…';
    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) throw new Error('add');
      await refreshCartCount();
      button.textContent = 'Ajouté';
      setTimeout(function () { button.textContent = original; button.disabled = false; }, 1400);
    } catch (err) {
      button.textContent = 'Erreur';
      setTimeout(function () { button.textContent = original; button.disabled = false; }, 1800);
    }
  });
  var ratingBox = document.querySelector('[data-product-rating]');
  function summarizeRating() {
    var badge = ratingBox.querySelector('.jdgm-prev-badge');
    if (!badge) return false;
    var avg = parseFloat(badge.getAttribute('data-average-rating'));
    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
    if (isNaN(avg) || isNaN(count)) return false;
    var meta = ratingBox.querySelector('[data-rating-meta]');
    var empty = ratingBox.querySelector('[data-rating-empty]');
    var summary = ratingBox.querySelector('[data-rating-summary]');
    if (count > 0 && avg > 0) {
      summary.textContent = avg.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) +
        '/5 (' + count.toLocaleString('fr-FR') + (count > 1 ? ' avis)' : ' avis)');
      meta.hidden = false; empty.hidden = true; ratingBox.classList.add('has-summary');
    } else {
      meta.hidden = true; empty.hidden = false; ratingBox.classList.add('is-empty');
    }
    return true;
  }
  if (ratingBox && !summarizeRating()) {
    var observer = new MutationObserver(function () {
      if (summarizeRating()) observer.disconnect();
    });
    observer.observe(ratingBox, { childList: true, subtree: true, attributes: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-write-review]');
    if (!trigger) return;
    var section = document.getElementById('avis-clients');
    var nativeButton = document.querySelector('.jdgm-write-rev-link');
    if (!section || !nativeButton) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    nativeButton.click();
  });
})();

/* Menu adaptatif : mesure des liens sans modifier le logo. */
(function () {
  var cleanup;
  function initialize() {
    if (cleanup) cleanup();
    var header = document.querySelector('.site-header:not([data-asphalt-probe])');
    if (!header) return;
    var inner = header.querySelector('.header-inner');
    if (!inner) return;
    /* Garder les liens secondaires accessibles dans le menu compact. */
    var mobileMenu = header.querySelector('.mobile-menu');
    if (mobileMenu) {
      header.querySelectorAll('.nav-right a').forEach(function (link) {
        var exists = Array.from(mobileMenu.querySelectorAll('a')).some(function (item) {
          return item.getAttribute('href') === link.getAttribute('href');
        });
        if (!exists) mobileMenu.appendChild(link.cloneNode(true));
      });
    }
    var frame = 0, probe, sizes;
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    function rebuildProbe() {
      if (sizes) sizes.disconnect();
      if (probe) probe.remove();
      probe = document.createElement('div');
      probe.className = 'site-header';
      probe.setAttribute('data-asphalt-probe', '');
      probe.setAttribute('aria-hidden', 'true');
      probe.setAttribute('inert', '');
      var copy = inner.cloneNode(true);
      copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      copy.querySelectorAll('[data-cart-count]').forEach(function (el) { el.removeAttribute('data-cart-count'); });
      copy.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = -1; });
      probe.appendChild(copy);
      document.body.appendChild(probe);
      if (sizes) {
        sizes.observe(inner);
        ['.brand', '.nav-left', '.header-end'].forEach(function (selector) {
          sizes.observe(copy.querySelector(selector));
        });
      }
      schedule();
    }
    function update() {
      frame = 0;
      if (!header.isConnected || !probe) return;
      probe.style.width = header.getBoundingClientRect().width + 'px';
      var sample = probe.querySelector('.header-inner');
      var left = sample.querySelector('.nav-left');
      var brand = sample.querySelector('.brand');
      var right = sample.querySelector('.header-end');
      if (!left || !brand || !right) return;
      var style = getComputedStyle(sample);
      var available = sample.getBoundingClientRect().width -
        parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      var side = (available - brand.getBoundingClientRect().width -
        2 * (parseFloat(style.columnGap) || 0)) / 2;
      var wide = window.matchMedia('(min-width: 1251px)').matches &&
        left.getBoundingClientRect().width + 12 <= side &&
        right.getBoundingClientRect().width + 12 <= side;
      var wasWide = header.classList.contains('asphalt-menu-wide');
      header.classList.toggle('asphalt-menu-wide', wide);
      if (wide && !wasWide) {
        var menu = header.querySelector('.mobile-menu');
        var toggle = header.querySelector('.mobile-toggle');
        var restoreFocus = (menu && menu.contains(document.activeElement)) || toggle === document.activeElement;
        if (menu) menu.hidden = true;
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Ouvrir le menu');
        }
        if (restoreFocus) header.querySelector('.brand').focus();
      } else if (!wide && wasWide) {
        var focusedNav = document.activeElement && document.activeElement.closest('.desktop-nav');
        if (focusedNav && header.contains(focusedNav)) header.querySelector('.mobile-toggle').focus();
      }
    }
    sizes = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    rebuildProbe();
    var changes = new MutationObserver(rebuildProbe);
    changes.observe(inner, { childList: true, characterData: true, subtree: true });
    window.addEventListener('resize', schedule);
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
    cleanup = function () {
      cancelAnimationFrame(frame);
      if (sizes) sizes.disconnect();
      changes.disconnect();
      window.removeEventListener('resize', schedule);
      if (document.fonts) document.fonts.removeEventListener('loadingdone', schedule);
      probe.remove();
    };
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
